// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yehp","content":"styles_content__a23pm"};